// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('club-sauce/public/project/index.raw').LWApiPublicProjectAvailableParamsRawI} params
 * @param {import('@tanstack/react-query').UseQueryOptions<import('club-sauce/public/project/index.raw').LWApiPublicProjectAvailableResultRawI>} [options]
 */
const useProjectAvailable = (params, options) =>
	useQuery({
		queryKey: ['/project/available', params],
		queryFn: () => api.project.apiRaw.available(params),
		...options,
	});

export default useProjectAvailable;
